import React, { useState, useEffect } from 'react';
import { FaChartLine, FaArrowLeft, FaCheckCircle, FaUsers, FaTimes, FaHistory } from 'react-icons/fa';
import { MdOutlineCurrencyExchange, MdCurrencyBitcoin } from 'react-icons/md';
import { IoWallet } from 'react-icons/io5';
import { SiEthereum, SiRipple } from 'react-icons/si';
import BottomNavigation from './BottomNavigation';
import { useAuth } from '../security/security/AuthContext';
import axios from 'axios';
import HotProductSection from './HotProductSection';

const Products = () => {
  // State management
  const [currentView, setCurrentView] = useState('main');
  const [depositAmount, setDepositAmount] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [products, setProducts] = useState([]);
  const [toastNotification, setToastNotification] = useState(null);
  const [investmentSuccess, setInvestmentSuccess] = useState(null);
  const { userDetails, token, updateUserDetails, isLoading } = useAuth();

  
  // Payment processing states
  const [showPaymentLoader, setShowPaymentLoader] = useState(false);
  const [paymentLoaderMessage, setPaymentLoaderMessage] = useState('');
  const [showTransactionForm, setShowTransactionForm] = useState(false);
  const [transactionCode, setTransactionCode] = useState('');
  const [isSubmittingPayment, setIsSubmittingPayment] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [isActivated, setIsActivated] = useState(false);
  const [hotProduct, setHotProduct] = useState(null);
  const [showInvestmentDialog, setShowInvestmentDialog] = useState(false);

  // Styles
  const styles = {
    container: {
      backgroundColor: '#0F172A',
      color: '#E2E8F0',
      minHeight: '100vh',
      paddingBottom: '80px',
      fontFamily: 'Inter, system-ui, sans-serif',
    },
    header: {
      background: 'linear-gradient(135deg, #1E293B 0%, #0F172A 100%)',
      padding: '16px',
      borderBottom: '1px solid #1E3A5F',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    balanceCard: {
      background: 'linear-gradient(135deg, #1E3A5F 0%, #0C4A6E 100%)',
      borderRadius: '12px',
      padding: '16px',
      margin: '16px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
      position: 'relative',
      overflow: 'hidden',
    },
    balanceHeader: {
      fontSize: '14px',
      color: '#94A3B8',
      marginBottom: '8px',
    },
    balanceAmount: {
      fontSize: '28px',
      fontWeight: 'bold',
      marginBottom: '8px',
      display: 'flex',
      alignItems: 'center',
    },
    balanceActions: {
      display: 'flex',
      gap: '12px',
      marginTop: '12px',
    },
    actionButton: {
      backgroundColor: '#0284C7',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      padding: '10px 16px',
      fontSize: '14px',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    },
    sectionTitle: {
      fontSize: '18px',
      fontWeight: '600',
      margin: '24px 16px 16px',
      color: '#E2E8F0',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    productsList: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
      gap: '16px',
      padding: '0 16px',
    },
    productCard: {
      background: 'linear-gradient(145deg, #1E293B 0%, #0F172A 100%)',
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      border: '1px solid #1E3A5F',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    },
    productImage: {
      width: '100%',
      height: '160px',
      objectFit: 'cover',
      borderBottom: '1px solid #1E3A5F',
    },
    productInfo: {
      padding: '16px',
    },
    productName: {
      fontSize: '18px',
      fontWeight: '600',
      marginBottom: '8px',
      color: '#F8FAFC',
    },
    productDetail: {
      fontSize: '14px',
      color: '#94A3B8',
      marginBottom: '4px',
      display: 'flex',
      justifyContent: 'space-between',
    },
    productStats: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '8px',
      padding: '0 16px 16px',
      borderTop: '1px solid #1E3A5F',
      paddingTop: '12px',
    },
    statBox: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    statValue: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#38BDF8',
    },
    statLabel: {
      fontSize: '12px',
      color: '#94A3B8',
      textAlign: 'center',
    },
    investButton: {
      width: '100%',
      backgroundColor: '#0284C7',
      color: 'white',
      border: 'none',
      borderRadius: '0 0 12px 12px',
      padding: '12px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease',
    },
    investDialog: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      padding: '16px',
    },
    dialogContent: {
      backgroundColor: '#1E293B',
      borderRadius: '16px',
      width: '100%',
      maxWidth: '420px',
      position: 'relative',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.5)',
      border: '1px solid #38BDF8',
      overflow: 'hidden',
    },
    dialogHeader: {
      padding: '16px',
      borderBottom: '1px solid #2D3748',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    dialogTitle: {
      fontSize: '20px',
      fontWeight: '600',
      color: '#F8FAFC',
    },
    closeButton: {
      backgroundColor: 'transparent',
      border: 'none',
      color: '#94A3B8',
      fontSize: '20px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    dialogBody: {
      padding: '16px',
    },
    quantitySelector: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px',
      marginBottom: '16px',
    },
    quantityButton: {
      flex: '1 0 calc(33.333% - 8px)',
      padding: '12px 0',
      backgroundColor: '#2D3748',
      border: 'none',
      borderRadius: '8px',
      color: '#E2E8F0',
      fontSize: '16px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    },
    activeQuantityButton: {
      backgroundColor: '#0284C7',
      color: 'white',
      boxShadow: '0 0 0 2px #38BDF8',
    },
    detailRow: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '12px 0',
      borderBottom: '1px solid #2D3748',
    },
    detailLabel: {
      color: '#94A3B8',
    },
    detailValue: {
      color: '#F8FAFC',
      fontWeight: '500',
    },
    confirmButton: {
      width: '100%',
      padding: '16px',
      marginTop: '16px',
      backgroundColor: '#0284C7',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease',
    },
    backButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '12px 16px',
      backgroundColor: 'transparent',
      border: 'none',
      color: '#E2E8F0',
      fontSize: '16px',
      cursor: 'pointer',
    },
    successView: {
      padding: '24px 16px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
    },
    successIcon: {
      fontSize: '80px',
      color: '#10B981',
      marginBottom: '16px',
    },
    successTitle: {
      fontSize: '24px',
      fontWeight: '600',
      marginBottom: '16px',
      color: '#F8FAFC',
    },
    depositForm: {
      padding: '16px',
    },
    depositInput: {
      width: '100%',
      padding: '16px',
      backgroundColor: '#1E293B',
      border: '1px solid #2D3748',
      borderRadius: '8px',
      color: '#F8FAFC',
      fontSize: '16px',
      marginBottom: '16px',
    },
    loaderContainer: {
      padding: '24px 16px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
    },
    loader: {
      border: '4px solid #1E293B',
      borderTop: '4px solid #38BDF8',
      borderRadius: '50%',
      width: '50px',
      height: '50px',
      animation: 'spin 1s linear infinite',
      marginBottom: '16px',
    },
    cryptoIcon: {
      marginRight: '8px',
      fontSize: '24px',
    },
    currencySymbol: {
      fontSize: '16px',
      marginRight: '4px',
      opacity: 0.7,
    },
    iconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      backgroundColor: 'rgba(56, 189, 248, 0.2)',
      marginRight: '12px',
    },
    toast: {
      position: 'fixed',
      bottom: '80px',
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: '#1E293B',
      color: 'white',
      padding: '12px 16px',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      zIndex: 1001,
      width: '90%',
      maxWidth: '400px',
      border: '1px solid',
    },
    successToast: {
      borderColor: '#10B981',
    },
    errorToast: {
      borderColor: '#EF4444',
    },
    coinIcons: {
      display: 'flex',
      position: 'absolute',
      right: '16px',
      top: '16px',
    },
    coinIcon: {
      width: '20px',
      height: '20px',
      marginLeft: '4px',
      opacity: 0.7,
    }
  };

  useEffect(() => {
    if (!isLoading && userDetails?.mobile) {
      setPhoneNumber(userDetails.mobile);
    }
    if (!isLoading && userDetails?.email) {
      fetchAvailableProducts();
    }
  }, [userDetails, isLoading]);

  const formatPhoneNumber = (number) => {
    if (number.startsWith('07') || number.startsWith('01')) {
      return '254' + number.slice(1);
    }
    return number;
  };

  // Data refresh functions
  const refreshUserData = async () => {
    try {
      const userResponse = await axios.get(`https://api.novasoftwaves.com/api/v1/auth/${userDetails.email}`, {
        headers: {
          'Authorization': token
        }
      });
      updateUserDetails(userResponse.data);
    } catch (error) {
      console.error('Error refreshing user data:', error);
      setToastNotification({ message: 'Failed to refresh user data', type: 'error' });
    }
  };

  const refreshProducts = async () => {
    try {
      const response = await axios.get(`https://api.novasoftwaves.com/api/products/available/${userDetails.email}`);
      if (response.data && Array.isArray(response.data)) {
        setProducts(response.data);
      }
    } catch (error) {
      console.error('Error refreshing products:', error);
    }
  };

  const refreshAllData = async () => {
    await Promise.all([
      refreshUserData(),
      refreshProducts()
    ]);
  };

  useEffect(() => {
    if (currentView === 'main') {
      refreshAllData();
    }
  }, [currentView]);

  const handlePaymentSuccess = async () => {
    await refreshAllData();
    setCurrentView('paymentSuccess');
  };

  const fetchAvailableProducts = async () => {
    try {
      const [productsResponse, hotProductsResponse] = await Promise.all([
        axios.get(`https://api.novasoftwaves.com/api/products/available/${userDetails.email}`),
        axios.get('https://api.novasoftwaves.com/api/products/hot')
      ]);
      
      if (productsResponse.data && Array.isArray(productsResponse.data)) {
        setProducts(productsResponse.data.filter(p => p.productType === 'NORMAL'));
      }
      
      if (hotProductsResponse.data && hotProductsResponse.data.length > 0) {
        setHotProduct(hotProductsResponse.data[0]);
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      setToastNotification({ message: 'Failed to fetch mining currencies. Please try again.', type: 'error' });
    }
  };

  const handleInvest = (product) => {
    setSelectedProduct(product);
    setQuantity(1);
    setShowInvestmentDialog(true);
  };

  const handleCloseInvestmentDialog = () => {
    setShowInvestmentDialog(false);
    setSelectedProduct(null);
    setQuantity(1);
  };

  const handleQuantityChange = (newQuantity) => {
    setQuantity(newQuantity);
  };

  const calculateTotalBalance = () => {
    const wallet = Number(userDetails.wallet) || 0;
    const invitationIncome = Number(userDetails.invitationIncome) || 0;
    return (wallet + invitationIncome).toLocaleString();
  };

  const handleInvestNow = async () => {
    try {
      const response = await axios.post('https://api.novasoftwaves.com/api/investments/invest', null, {
        params: {
          userEmail: userDetails.email,
          productId: selectedProduct.id,
          quantity: quantity
        }
      });
      
      if (response.status === 200) {
        await refreshAllData();
        setShowInvestmentDialog(false);
        setInvestmentSuccess(response.data);
        setCurrentView('investmentSuccess');
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setToastNotification({ message: error.response.data, type: 'error' });
        setCurrentView('deposit');
        setDepositAmount((selectedProduct.price * quantity).toString());
      } else {
        console.error('Error making investment:', error);
        setToastNotification({ message: 'Transaction failed. Please try again!', type: 'error' });
      }
    }
  };

  // Payment processing functions
  const handlePaymentSubmit = async (e) => {
    e.preventDefault();
    setShowPaymentLoader(true);
    setPaymentLoaderMessage('Please check your phone to complete payment.');

    const formattedPhoneNumber = formatPhoneNumber(phoneNumber);
    const requestData = {
      PhoneNumber: formattedPhoneNumber,
      Amount: parseInt(depositAmount),
    };

    try {
      await axios.post('https://api.novasoftwaves.com/mobile-money/stk-transaction-request', requestData, {
        headers: {
          'Authorization': token
        }
      });
      
      setTimeout(() => {
        setPaymentLoaderMessage('Processing transaction...');
      }, 20000);

      setTimeout(() => {
        checkPaymentStatus(formattedPhoneNumber);
      }, 27000);
    } catch (error) {
      console.error(error);
      setShowPaymentLoader(false);
      setToastNotification({ message: 'Failed to initiate payment. Please try again.', type: 'error' });
    }
  };

  const checkPaymentStatus = async (phoneNumber) => {
    try {
      const response = await axios.get(`https://api.novasoftwaves.com/mobile-money/transactions/check-payment/${phoneNumber}`, {
        headers: {
          'Authorization': token
        }
      });
  
      if (response.data.paymentFound) {
        await processTransaction(phoneNumber);
        setPaymentSuccess(true);
        setShowPaymentLoader(false);
        setToastNotification({ message: 'Payment successful!', type: 'success' });
        setCurrentView('paymentSuccess');
      } else {
        setShowPaymentLoader(false);
        setShowTransactionForm(true);
      }
    } catch (error) {
      console.error('Error checking payment status:', error);
      setShowPaymentLoader(false);
      setToastNotification({ message: 'Failed to check payment status. Please try again.', type: 'error' });
    }
  };

  const processTransaction = async (phoneNumber) => {
    try {
      const response = await axios.post('https://api.novasoftwaves.com/mobile-money/users/activate', {
        phoneNumber: phoneNumber,
        email: userDetails.email
      }, {
        headers: {
          'Authorization': token
        }
      });
  
      if (response.data.message) {
        setIsActivated(true);
        await refreshAllData();
      }
    } catch (error) {
      console.error('Error processing transaction:', error);
      throw error;
    }
  };

  const handleTransactionCodeSubmit = async (e) => {
    e.preventDefault();
    setIsSubmittingPayment(true);
  
    const formattedPhoneNumber = formatPhoneNumber(phoneNumber);
  
    try {
      const verifyResponse = await axios.post('https://api.novasoftwaves.com/mobile-money/transactions/verify', {
        phoneNumber: formattedPhoneNumber,
        transactionCode: transactionCode
      }, {
        headers: {
          'Authorization': token
        }
      });
  
      if (verifyResponse.data.verified) {
        await processTransaction(formattedPhoneNumber);
        await refreshAllData();
        setPaymentSuccess(true);
        setCurrentView('paymentSuccess');
        setToastNotification({ message: 'Payment verified successfully!', type: 'success' });
      } else {
        setToastNotification({ message: 'Invalid transaction code. Please try again.', type: 'error' });
      }
    } catch (error) {
      console.error('Error verifying transaction:', error);
      setToastNotification({ message: 'Failed to verify transaction. Please try again.', type: 'error' });
    } finally {
      setIsSubmittingPayment(false);
    }
  };

  // View renderers
  const renderInvestmentSuccessView = () => (
    <div style={styles.successView}>
      <FaCheckCircle style={styles.successIcon} />
      <h2 style={styles.successTitle}>Investment Successful!</h2>
      <div style={{...styles.productCard, marginBottom: '24px', width: '100%'}}>
        <div style={styles.productInfo}>
          <h3 style={styles.productName}>{investmentSuccess.productName}</h3>
          
          <div style={styles.detailRow}>
            <div style={styles.detailLabel}>Investment Amount</div>
            <div style={styles.detailValue}>KES {investmentSuccess.investedAmount.toLocaleString()}</div>
          </div>
          
          <div style={styles.detailRow}>
            <div style={styles.detailLabel}>Quantity</div>
            <div style={styles.detailValue}>{quantity} units</div>
          </div>
          
          <div style={styles.detailRow}>
            <div style={styles.detailLabel}>Daily Yield</div>
            <div style={styles.detailValue}>KES {investmentSuccess.dailyIncome.toLocaleString()}</div>
          </div>
          
          <div style={styles.detailRow}>
            <div style={styles.detailLabel}>Total Expected Return</div>
            <div style={styles.detailValue}>KES {investmentSuccess.totalIncome.toLocaleString()}</div>
          </div>
          
          <div style={styles.detailRow}>
            <div style={styles.detailLabel}>Mining Cycle Ends</div>
            <div style={styles.detailValue}>{investmentSuccess.validUntil.split('T')[0]}</div>
          </div>
        </div>
      </div>
      
      <div style={{...styles.productCard, padding: '16px', marginBottom: '24px', width: '100%'}}>
        <h3 style={{...styles.productName, fontSize: '16px'}}>How to Collect Mining Rewards</h3>
        <p style={{color: '#94A3B8', marginBottom: '8px'}}>Your mining rewards will be added to your wallet every hour. Check the Portfolio page regularly.</p>
        <p style={{color: '#94A3B8'}}>When the mining cycle completes, your initial investment will automatically return to your balance.</p>
      </div>
      
      <button 
        style={{...styles.confirmButton, backgroundColor: '#10B981', marginBottom: '12px'}}
        onClick={() => window.location.href = '/order'}
      >
        View Mining Operations
      </button>
      
      <button 
        style={{...styles.backButton, width: '100%'}}
        onClick={() => setCurrentView('main')}
      >
        Back to Dashboard
      </button>
    </div>
  );

  const renderMainView = () => (
    <>
      <div style={styles.header}>
        <h1 style={{fontSize: '20px', fontWeight: '600'}}>Crypto Mining</h1>
        <div style={styles.coinIcons}>
          <MdCurrencyBitcoin style={{...styles.coinIcon, color: '#F7931A'}} />
          <SiEthereum style={{...styles.coinIcon, color: '#627EEA'}} />
          <SiRipple style={{...styles.coinIcon, color: '#006AFF'}} />
        </div>
      </div>
      
      <div style={styles.balanceCard}>
        <div style={styles.balanceHeader}>Total Available Balance</div>
        <div style={styles.balanceAmount}>
          <span style={styles.currencySymbol}>KES</span> {calculateTotalBalance()}
        </div>
        <div style={styles.balanceActions}>
          <button 
            style={styles.actionButton}
            onClick={() => setCurrentView('deposit')}
          >
            <IoWallet size={18} /> Deposit
          </button>
        </div>
      </div>

      {hotProduct && (
        <HotProductSection product={hotProduct} onInvest={handleInvest} />
      )}

      {products.length > 0 && (
        <>
          <h2 style={styles.sectionTitle}>
            <MdCurrencyBitcoin /> Available Mining Currencies
          </h2>
          <div style={styles.productsList}>
            {products.map((product, index) => (
              <div key={index} style={styles.productCard}>
                <img 
                  src={`https://api.novasoftwaves.com${product.imageUrl}`} 
                  alt={product.name} 
                  style={styles.productImage}
                />
                <div style={styles.productInfo}>
                  <h3 style={styles.productName}>{product.name}</h3>
                  <div style={styles.productDetail}>
                    <span>Mining Period</span>
                    <span>{product.cycle} days</span>
                  </div>
                  <div style={styles.productDetail}>
                    <span>Available Stock</span>
                    <span>{product.available} units</span>
                  </div>
                </div>
                <div style={styles.productStats}>
                  <div style={styles.statBox}>
                    <div style={styles.statValue}>{product.dailyIncome}</div>
                    <div style={styles.statLabel}>Daily Yield (KES)</div>
                  </div>
                  <div style={styles.statBox}>
                    <div style={styles.statValue}>{product.totalIncome}</div>
                    <div style={styles.statLabel}>Total Return (KES)</div>
                  </div>
                  <div style={styles.statBox}>
                    <div style={styles.statValue}>{product.price}</div>
                    <div style={styles.statLabel}>Price (KES)</div>
                  </div>
                </div>
                <button 
                  style={{
                    ...styles.investButton, 
                    backgroundColor: product.available < 1 ? '#475569' : '#0284C7',
                    cursor: product.available < 1 ? 'not-allowed' : 'pointer'
                  }}
                  onClick={() => product.available >= 1 && handleInvest(product)}
                  disabled={product.available < 1}
                >
                  {product.available < 1 ? 'Sold Out' : 'Start Mining'}
                </button>
              </div>
            ))}
          </div>
        </>
      )}

      {showInvestmentDialog && selectedProduct && (
        <div style={styles.investDialog}>
          <div style={styles.dialogContent}>
            <div style={styles.dialogHeader}>
              <h3 style={styles.dialogTitle}>Start Mining</h3>
              <button style={styles.closeButton} onClick={handleCloseInvestmentDialog}>
                <FaTimes />
              </button>
            </div>
            <div style={styles.dialogBody}>
              <h4 style={{...styles.productName, marginBottom: '16px'}}>{selectedProduct.name}</h4>
              
              <div style={{marginBottom: '16px'}}>
                <div style={{color: '#94A3B8', marginBottom: '8px'}}>Select quantity:</div>
                <div style={styles.quantitySelector}>
                  {[...Array(Math.min(selectedProduct.available, 6))].map((_, index) => (
                    <button
                      key={index + 1}
                      style={{
                        ...styles.quantityButton,
                        ...(quantity === index + 1 ? styles.activeQuantityButton : {})
                      }}
                      onClick={() => handleQuantityChange(index + 1)}
                    >
                      {index + 1}
                    </button>
                  ))}
                </div>
              </div>
              
              <div style={styles.detailRow}>
                <div style={styles.detailLabel}>Daily Yield</div>
                <div style={styles.detailValue}>KES {selectedProduct.dailyIncome * quantity}</div>
              </div>
              
              <div style={styles.detailRow}>
                <div style={styles.detailLabel}>Total Return</div>
                <div style={styles.detailValue}>KES {selectedProduct.totalIncome * quantity}</div>
              </div>
              
              <div style={styles.detailRow}>
                <div style={styles.detailLabel}>Available Stock</div>
                <div style={styles.detailValue}>{selectedProduct.available} units</div>
              </div>
              
              <div style={styles.detailRow}>
                <div style={styles.detailLabel}>Total Investment</div>
                <div style={{...styles.detailValue, color: '#38BDF8', fontWeight: '700'}}>
                  KES {selectedProduct.price * quantity}
                </div>
              </div>
              
              <button 
                style={styles.confirmButton}
                onClick={handleInvestNow}
              >
                CONFIRM MINING OPERATION
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );

  const renderPaymentProcessView = () => (
    <div>
      <div style={styles.header}>
        <button 
          style={styles.backButton}
          onClick={() => setCurrentView('deposit')}
        >
          <FaArrowLeft /> Back
        </button>
        <h1 style={{fontSize: '18px', fontWeight: '600'}}>Process Payment</h1>
      </div>
      
      {!showPaymentLoader && !showTransactionForm && (
        <div style={styles.depositForm}>
          <div style={{...styles.productCard, padding: '16px', marginBottom: '16px'}}>
            <div style={styles.detailRow}>
              <div style={styles.detailLabel}>Deposit Amount</div>
              <div style={styles.detailValue}>KES {depositAmount}</div>
            </div>
            <div style={styles.detailRow}>
              <div style={styles.detailLabel}>Payment Method</div>
              <div style={styles.detailValue}>Mobile Money</div>
            </div>
            <div style={styles.detailRow}>
              <div style={styles.detailLabel}>Phone Number</div>
              <div style={styles.detailValue}>{phoneNumber}</div>
            </div>
          </div>
          
          <button 
            style={styles.confirmButton}
            onClick={handlePaymentSubmit}
          >
            CONTINUE TO PAYMENT
          </button>
        </div>
      )}
      
      {showPaymentLoader && (
        <div style={styles.loaderContainer}>
          <div style={styles.loader}></div>
          <h3 style={{fontSize: '18px', fontWeight: '600', marginBottom: '12px'}}>Processing Payment</h3>
          <p style={{color: '#94A3B8'}}>{paymentLoaderMessage}</p>
        </div>
      )}
      
      {showTransactionForm && (
        <div style={styles.depositForm}>
          <div style={{...styles.productCard, padding: '16px', marginBottom: '16px', borderColor: '#EF4444'}}>
            <h3 style={{...styles.productName, color: '#EF4444', textAlign: 'center'}}>Payment Not Detected</h3>
            <p style={{color: '#94A3B8', textAlign: 'center', margin: '12px 0'}}>
              Please try initiating the payment again. If you've already made the payment, contact support.
            </p>
          </div>
          
          <button 
            style={{...styles.confirmButton, backgroundColor: '#475569'}}
            onClick={() => setCurrentView('deposit')}
          >
            TRY AGAIN
          </button>
        </div>
      )}
    </div>
  );

  const renderPaymentSuccessView = () => (
    <div style={styles.successView}>
      <FaCheckCircle style={styles.successIcon} />
      <h2 style={styles.successTitle}>Payment Successful!</h2>
      <div style={{...styles.productCard, padding: '16px', marginBottom: '24px', width: '100%'}}>
        <div style={styles.detailRow}>
          <div style={styles.detailLabel}>Amount</div>
          <div style={styles.detailValue}>KES {depositAmount}</div>
        </div>
        <div style={styles.detailRow}>
          <div style={styles.detailLabel}>Status</div>
          <div style={{...styles.detailValue, color: '#10B981'}}>Completed</div>
        </div>
        {isActivated && (
          <div style={{marginTop: '12px', padding: '8px', backgroundColor: 'rgba(16, 185, 129, 0.1)', borderRadius: '8px', textAlign: 'center'}}>
            <p style={{color: '#10B981'}}>Your wallet has been successfully topped up!</p>
          </div>
        )}
      </div>
      
      <button 
        style={{...styles.confirmButton, backgroundColor: '#10B981'}}
        onClick={async () => {
          await refreshAllData();
          setCurrentView('main');
          setDepositAmount('');
          setPaymentSuccess(false);
          setShowTransactionForm(false);
        }}
      >
        BACK TO DASHBOARD
      </button>
    </div>
  );

  const renderDepositView = () => (
    <div>
      <div style={styles.header}>
        <button 
          style={styles.backButton}
          onClick={() => setCurrentView('main')}
        >
          <FaArrowLeft /> Back
        </button>
        <h1 style={{fontSize: '18px', fontWeight: '600'}}>Deposit Funds</h1>
      </div>
      
      <div style={styles.depositForm}>
        <div style={{marginBottom: '16px'}}>
          <label style={{color: '#94A3B8', marginBottom: '8px', display: 'block'}}>
            Enter Deposit Amount (Minimum: KES 300)
          </label>
          <input
            type="number"
            placeholder="Amount"
            value={depositAmount}
            onChange={(e) => {
              const value = e.target.value;
              setDepositAmount(value);
              if (toastNotification) {
                setToastNotification(null);
              }
            }}
            style={styles.depositInput}
          />
        </div>
        
        <button 
          style={{
            ...styles.confirmButton,
            backgroundColor: !depositAmount || parseFloat(depositAmount) < 300 ? '#475569' : '#0284C7',
            cursor: !depositAmount || parseFloat(depositAmount) < 300 ? 'not-allowed' : 'pointer'
          }}
          onClick={() => {
            if (!depositAmount || parseFloat(depositAmount) < 300) {
              setToastNotification({ 
                message: 'Minimum deposit amount is KES 300', 
                type: 'error' 
              });
              return;
            }
            setCurrentView('paymentProcess');
          }}
          disabled={!depositAmount || parseFloat(depositAmount) < 300}
        >
          PROCEED TO PAYMENT
        </button>
      </div>
    </div>
  );

  const renderView = () => {
    switch (currentView) {
      case 'deposit':
        return renderDepositView();
      case 'paymentProcess':
        return renderPaymentProcessView();
      case 'paymentSuccess':
        return renderPaymentSuccessView();
      case 'investmentSuccess':
        return renderInvestmentSuccessView();
      default:
        return renderMainView();
    }
  };

  return (
    <div style={styles.container}>
      {renderView()}
      <BottomNavigation />
      {toastNotification && (
        <div style={{
          ...styles.toast,
          ...(toastNotification.type === 'success' ? styles.successToast : styles.errorToast)
        }}>
          {toastNotification.type === 'success' ? (
            <FaCheckCircle color="#10B981" />
          ) : (
            <FaTimes color="#EF4444" />
          )}
          <div>{toastNotification.message}</div>
        </div>
      )}
    </div>
  );
};

export default Products;
